import React from "react";
import {
  CalenderIcon1,
  CallIcon,
  ClockIconV3,
  HourglassIcon,
  PersonIcon,
  RupeeIcon,
} from "../../images/icons/icons";
import { convertStraight, convertThenFormat } from "../common-data/Converts";

const ToaserInfo = ({ from, rowData }) => {
  const hasKey = (key) =>
    rowData?.[key] !== undefined &&
    rowData?.[key] !== null &&
    rowData?.[key] !== "" &&
    rowData?.[key] !== "NA";

  return (
    <div className="live-subscription-subscription-details">
      {hasKey("current_plan_name") || hasKey("plan_name") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <PersonIcon />
          </div>
          <div className="live-subscription-detail-label">plan name</div>
          <div className="live-subscription-detail-value">
            {rowData?.current_plan_name || rowData?.plan_name || "-"}
          </div>
        </div>
      ) : null}

      {from !== "new_subscription" && hasKey("price") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <RupeeIcon />
          </div>
          <div className="live-subscription-detail-label">plan price</div>
          <div className="live-subscription-detail-value highlight">
            ₹{convertThenFormat(rowData?.price || 0)}
          </div>
        </div>
      ) : null}

      {hasKey("duration") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <ClockIconV3 color="gray" />
          </div>
          <div className="live-subscription-detail-label">plan Duration</div>
          <div className="live-subscription-detail-value">
            {rowData?.duration || "-"} days
          </div>
        </div>
      ) : null}

      {hasKey("start_date") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <CalenderIcon1 />
          </div>
          <div className="live-subscription-detail-label">Start Date</div>
          <div className="live-subscription-detail-value">
            {convertStraight(rowData?.start_date || "-")}
          </div>
        </div>
      ) : null}

      {hasKey("expire_date") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <CalenderIcon1 />
          </div>
          <div className="live-subscription-detail-label">Expire Date</div>
          <div className="live-subscription-detail-value">
            {convertStraight(rowData?.expire_date || "-")}
          </div>
        </div>
      ) : null}

      {hasKey("current_subscription_expiry_days") ||
      hasKey("subscription_expiry_days") ||
      hasKey("days_remaining") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <HourglassIcon color="gray" />
          </div>
          <div className="live-subscription-detail-label">
            subscription expiring in (days)
          </div>
          <div className="live-subscription-detail-value">
            {rowData?.current_subscription_expiry_days ||
              rowData?.subscription_expiry_days ||
              rowData?.days_remaining ||
              "-"}
          </div>
        </div>
      ) : null}

      {hasKey("created_by_name") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <PersonIcon />
          </div>
          <div className="live-subscription-detail-label">
            Subscription Added By
          </div>
          <div className="live-subscription-detail-value">
            {rowData?.created_by_name || "NA"}
          </div>
        </div>
      ) : null}

      {hasKey("created_by_mobile") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <CallIcon />
          </div>
          <div className="live-subscription-detail-label">Added By Mobile</div>
          <div className="live-subscription-detail-value">
            {rowData?.created_by_mobile || "NA"}
          </div>
        </div>
      ) : null}

      {from !== "renewals" && hasKey("trainer_name") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <PersonIcon />
          </div>
          <div className="live-subscription-detail-label">Trainer</div>
          <div className="live-subscription-detail-value">
            {rowData.trainer_name || "-"}
          </div>
        </div>
      ) : null}

      {from !== "renewals" && hasKey("trainer_mobile") ? (
        <div className="live-subscription-detail-item">
          <div className="live-subscription-detail-icon">
            <CallIcon />
          </div>
          <div className="live-subscription-detail-label">Trainer Mobile</div>
          <div className="live-subscription-detail-value">
            {rowData.trainer_mobile || "-"}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ToaserInfo;
